import { BlipNamespace } from "@/common/BlipNamespace";

export const ContentNamespace = Object.freeze({
  COLLECTION: BlipNamespace.COLLECTION,
  TOPIC: BlipNamespace.TOPIC,
  RADAR: BlipNamespace.RADAR,
  TRIVIA: BlipNamespace.TRIVIA,
  CHITCHAT: BlipNamespace.CHITCHAT,
});

export const ContentNamespaceOptions = Object.freeze([
  {
    value: ContentNamespace.RADAR,
    label: "트렌드",
  },
  {
    value: ContentNamespace.COLLECTION,
    label: "갤러리",
  },
  {
    value: ContentNamespace.TOPIC,
    label: "토픽",
  },
  {
    value: ContentNamespace.TRIVIA,
    label: "명언/TMI",
  },
  {
    value: ContentNamespace.CHITCHAT,
    label: "잡담",
  },
]);
